import { loadStripe } from '@stripe/stripe-js/pure'

loadStripe.setLoadParameters({ advancedFraudSignals: false })

let stripePromiseCache

const getStripe = () => {
  if (!stripePromiseCache) {
    const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    if (!key) {
      throw new Error(
        'Stripe publishable key is missing. Please set REACT_APP_STRIPE_PUBLISHABLE_KEY in your environment.'
      )
    }
    stripePromiseCache = loadStripe(key)
  }
  return stripePromiseCache
}

export default getStripe
